import React from "react";
import PropTypes from "prop-types";
import { Card, Collapse } from "antd";
import CompatibleList from "../../common/compatible-list";
import { toPatentDetailLink, toSetString, toDateString } from "../../../helpers/converters";

const Citations = props => {
  const data = {
    patents: (props.data.backward_citations || []).filter(d => d),
    refBys: props.data.forward_citations || [],
    npls: (props.data.citations_npl || []).map(npl => ({ title: npl }))
  };
  const columns = [
    {
      title: "Publication Number",
      dataIndex: "publication_number",
      key: "publication_number",
      width: 200,
      render: toPatentDetailLink
    },
    {
      title: "Priority Date",
      dataIndex: "priority_date",
      key: "priority_date",
      width: 150,
      render: val => toDateString(val)
    },
    {
      title: "Assignees",
      dataIndex: "assignee_current",
      key: "assignee_current",
      width: 250,
      render: toSetString
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 400
    }
  ];
  const columnsNPL = [{ title: "Title", dataIndex: "title", key: "title" }];
  const tableScroll = {
    x: 1000,
    y: 250
  };
  return (
    <Card title="Citations" bodyStyle={{ padding: 10 }}>
      <Collapse bordered={false} defaultActiveKey={["patents", "refBys", "npls"].filter(k => data[k].length > 0)}>
        <Collapse.Panel header={`Patent Art (${data.patents.length})`} key="patents">
          <CompatibleList dataSource={data.patents} columns={columns} rowKey="publication_number" size="small" pagination={false} scroll={tableScroll} />
        </Collapse.Panel>
        <Collapse.Panel header={`Non-Patent Literature (${data.npls.length})`} key="npls">
          <CompatibleList dataSource={data.npls} columns={columnsNPL} size="small" rowKey="title" pagination={false} scroll={tableScroll} />
        </Collapse.Panel>
        <Collapse.Panel header={`Referenced By (${data.refBys.length})`} key="refBys">
          <CompatibleList dataSource={data.refBys} columns={columns} rowKey="publication_number" size="small" pagination={false} scroll={tableScroll} />
        </Collapse.Panel>
      </Collapse>
    </Card>
  );
};

Citations.propTypes = {
  data: PropTypes.object.isRequired
};

export default Citations;
